<script setup>
import { slugify } from '#common/utils/slugify'

const props = defineProps({
  items: {
    type: Array,
    required: true,
  },
  label: {
    type: String,
    required: true,
  },
})

const metadata = useMetadata()
const emit = defineEmits(['change'])

const slugId = computed(() => {
  return props.items.map((i) => slugify(i.chipName)).join('_')
})

const checked = computed(() => {
  return props.items.every((i) => metadata.selectedRegionSlugs.includes(i.slug))
})

function handleCheckbox() {
  if (!checked.value) {
    props.items.forEach((item) => {
      metadata.selectRegion({ region: item })
    })
  } else {
    props.items.forEach((item) => {
      metadata.deselectRegion({ region: item })
    })
  }
  emit('change')
}
</script>

<template>
  <li>
    <input
      :id="slugId"
      type="checkbox"
      :checked="checked"
      @input="handleCheckbox"
    />
    <label :for="slugId"> {{ label }} </label>
  </li>
</template>
